import { Platform } from 'react-native';
import { requireOptionalNativeModule } from 'expo';

type PlayBillingConfigNative = { getCountryCodeAsync(): Promise<string | null> };

// Необязательный: на вебе, iOS и в сборке без модуля его просто нет.
const native = Platform.OS === 'android'
  ? requireOptionalNativeModule<PlayBillingConfigNative>('PlayBillingConfig')
  : null;

/**
 * CORE-1535 — страна аккаунта Google Play (ISO alpha-2, например `RU`), или
 * `null`, если узнать нельзя: не Android, модуля нет в сборке, Play недоступен.
 */
export async function getPlayCountryCode(): Promise<string | null> {
  if (!native) return null;
  try {
    const code = await native.getCountryCodeAsync();
    return code ? code.toUpperCase() : null;
  } catch {
    return null;
  }
}
